import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { CustomerListResponseOutputItemsItemCounts } from '@/api/generated';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface AnnotationBadgesProps {
  counts: CustomerListResponseOutputItemsItemCounts;
  className?: string;
}

const AnnotationBadges: FC<AnnotationBadgesProps> = ({
  counts,
  className,
}: AnnotationBadgesProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex flex-wrap gap-2', className)}>
      <Badge variant='unannotated'>
        {t('common.annotationLabel.unannotated')}: {counts.unannotated}
      </Badge>
      <Badge variant='annotated'>
        {t('common.annotationLabel.annotated')}: {counts.annotated}
      </Badge>
      <Badge variant='removed'>
        {t('common.annotationLabel.removed')}: {counts.removed}
      </Badge>
      <Badge variant='unknown'>
        {t('common.annotationLabel.unknown')}: {counts.unknown}
      </Badge>
    </div>
  );
};

export default AnnotationBadges;
